/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import HorizontalTeamCard from "parts/Cards/TeamCards/HorizontalTeamCard";

// Images
import team1 from "assets/images/12.png";
import team2 from "assets/images/13.jpg";
import team3 from "assets/images/14.webp";
import team4 from "assets/images/15.webp";

function Team() {
  return (
    <MKBox
      component="section"
      variant="gradient"
      bgColor="info"
      position="relative"
      py={6}
      px={{ xs: 2, lg: 0 }}
      mx={-2}
    >
      <Container>
        <Grid container>
          <Grid item xs={12} md={8} sx={{ mb: 6 }}>
            <MKTypography variant="h3" color="white">
            Why Choose Our Remote Desktop Support Services?
            </MKTypography>
            <MKTypography variant="body2" color="white" opacity={0.8}>
  At HP Tech Solutions, we provide more than just IT support—we deliver seamless remote desktop solutions to keep your business running smoothly. Our mission is to ensure secure, efficient, and scalable remote support services that enable businesses to stay productive, no matter where their teams are located.

  With a team of experienced professionals, we specialize in resolving technical issues, optimizing system performance, and maintaining robust security. Whether you need instant troubleshooting or ongoing desktop management, our services are designed to meet your unique business requirements and keep your operations on track.
</MKTypography>

          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team1}
                name="Expert Technicians"
                position={{ color: "info", label: "user-friendly" }}
                description="Our team of skilled professionals is equipped with the expertise to handle a wide range of IT issues and support needs."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team2}
                name="Quick Response Times"
                position={{ color: "info", label: "threat detection" }}
                description="We prioritize fast response times, ensuring that your technical issues are resolved promptly."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team3}
                name="Cost-Efficient"
                position={{ color: "info", label: "specific business goals" }}
                description="Remote support eliminates the need for on-site visits, reducing overall costs and minimizing disruption."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team4}
                name="Comprehensive Services"
                position={{ color: "info", label: "maximize ROI" }}
                description="From software installation to troubleshooting and training, we offer end-to-end remote support solutions."
              />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Team;
